import React, { Component } from "react";

import { Divide as Hamburger } from "hamburger-react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  Link,
} from "react-router-dom";
import ReactGA from "react-ga";

export default class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      menuColor: false,
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.listenToScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.listenToScroll);
  }

  listenToScroll = () => {
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;

    const height =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;

    const scrolled = winScroll;
    if (scrolled < 50) {
      this.setState((prevState) => ({
        menuColor: false,
      }));
    } else {
      this.setState((prevState) => ({
        menuColor: true,
      }));
    }
    this.setState({
      theposition: scrolled,
    });
  };

  setOpen() {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
    }));
  }

  triggerMenuClick = (func = "goto", type = "") => {
    ReactGA.event({
      category: "aastaloos_2022",
      action: "click",
      label: type,
    });

    if (func === "modal") {
      this.props.modal(type);
    } else {
      if(type === "miljoniloos" || type === "lisaloos"){
        this.props.toggleActiveTab(type)
      }
      this.props.goTo(type);

    }

    this.setOpen();
  };

  render() {
    const { isOpen } = this.state;
    const { language, activeTab } = this.props;
    return (
      <div className={`nav${this.state.menuColor ? " nav-withBG" : ""}`}>
         <img className="nav--logo" src="./assets/images/vikinglotto.svg" alt="Vikinglotto logo"/>
        <div className="nav--inside">
     
          <div className={`menu ${isOpen ? "is-open" : ""}`}>
          
          
        
            <button className={activeTab === "miljoniloos" ? "is-active" : ""} onClick={() => this.triggerMenuClick("goto", "miljoniloos")}>
              {language === "et" ? "Miljoniloos" : "Розыгрыш Миллиона"}
            </button>
            <button className={activeTab === "lisaloos" ? "is-active" : ""} onClick={() => this.triggerMenuClick("goto", "lisaloos")}>
              {language === "et" ? "Lisaloos" : "Дополнительный розыгрыш"}
            </button>
            <button onClick={() => this.triggerMenuClick("modal", "rules")}>
              {language === "et" ? "Reeglid" : "Правила"}
            </button>
            <button onClick={() => this.triggerMenuClick("modal", "prize")}>
              {language === "et" ? "Volvo XC60" : "Volvo XC60"}
            </button>
            <button onClick={() => this.triggerMenuClick("goto", "winners")}>
              {language === "et" ? "Võitjad" : "Победители "}
            </button>
          
          </div>
          <button className="language"
              onClick={() =>
                this.props.changeLanguage(language === "et" ? "ru" : "et")
              }
            >
              {language === "et" ? (
                <Link to="/ru">RUS</Link>
              ) : (
                <Link to="/et">EST</Link>
              )}
            </button>
            <Hamburger
            size={28}
            distance="lg"
            toggled={isOpen}
            toggle={() => this.setOpen()}
          />
        </div>
      </div>
    );
  }
}
